import styled from 'styled-components';
import { Fonts, Palette } from '../utils';

export const EntityImagesSection = styled.div`
  align-self: stretch;
  display: flex;
  flex-direction: column;
  gap: 12px;
`;

export const EntityImagesGrid = styled.div`
  align-self: stretch;
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 12px;
`;

export const EntityImageTile = styled.div`
  position: relative;
  aspect-ratio: 1;
  border-radius: 8px;
  overflow: hidden;
  background: ${Palette.GHOST_WHITE};
`;

export const EntityImageThumb = styled.img`
  width: 100%;
  height: 100%;
  object-fit: cover;
  display: block;
`;

export const EntityImageRemoveBtn = styled.button`
  position: absolute;
  top: 4px;
  right: 4px;
  width: 24px;
  height: 24px;
  padding: 0;
  border: none;
  border-radius: 999px;
  background: rgba(0, 0, 0, 0.55);
  color: ${Palette.WHITE};
  font-size: 14px;
  line-height: 1;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;

  &:hover {
    background: rgba(0, 0, 0, 0.72);
  }
`;

export const EntityCoverBadge = styled.span`
  position: absolute;
  left: 6px;
  top: 6px;
  padding: 2px 8px;
  border-radius: 999px;
  border: 1px solid ${Palette.GREEN_500};
  background: ${Palette.SURFACE_SUCCESS};
  color: ${Palette.GREEN_500};
  font-size: 10px;
  font-family: ${Fonts.OPEN_SANS_FONT}, sans-serif;
  font-weight: 600;
  line-height: 16px;
`;
